module.exports = __webpack_public_path__ + "img/webblack.ac037d74.svg";